import { isObject } from "lodash"

export const getFullAbbreviation = sty => {
  return `${sty.sectionAbbreviation} (${sty.schoolYearName})`
}

export const getFullName = sty => {
  return `${sty.sectionName} (${sty.schoolYearName})`
}

export const sortBySectionAndYear = (a, b) => {
  if(!isObject(a)) {
    return 1
  }
  if (!isObject(b)) {
    return -1
  }

  const abbreviation = (a.sectionAbbreviation ?? a.abbreviation).localeCompare((b.sectionAbbreviation ?? b.abbreviation))
  const schoolYearName = (a.schoolYearName ?? a.schoolYear.name).localeCompare((b.schoolYearName ?? b.schoolYear.name))

  return abbreviation || schoolYearName
}

export const reduceBySection = sectionToYears => sectionToYears.reduce(
  (acc, sty) => {
    const sectionId = sty.section === null ? -1 : sty.section.id

    if (!acc[sectionId]) {
      acc[sectionId] = []
    }

    acc[sectionId].push(sty)

    return acc
  }, {}
)